


import React, { useState } from 'react';
import main14 from './images/main-ads.png';

export default function Ads_Management_ser() {
  // State to track the currently active tab
  const [activeTab, setActiveTab] = useState('Tab1');

  // Handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Content for each tab
  const renderContent = () => {
    switch (activeTab) {
      case 'Tab1':
        return (
          <div className="tab-contain-full">
            <div className="main-tab-heading1 auto-focus">
              <h1>What Is Pay Per Click and How Does It Work?</h1>
            </div>
            <div className="main-para-area">
              <p>
              In 2017 alone, over 7 million advertisers spent more than $10 billion on pay-per-click (PPC) ads, according to Social Media Today. This highlights just how powerful and popular PPC has become for driving strong returns on investment.
But what exactly is pay per click, and how can it boost your digital marketing efforts?

              </p>
              <p>
              Our PPC specialists at Raj Digital Marketing break down the basics of paid search and how it functions to help you get started with confidence. Understanding how PPC works gives you a clear edge in launching campaigns that deliver real results.
              </p>
              <p>
              Explore the fundamentals of PPC marketing and discover how our expert pay per click marketing agency can help your business succeed.
              </p>
              <p>
                
              </p>
            </div>
          </div>
        );
      case 'Tab2':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>What is PPC?</h1>
            </div>
            <div className="main-para-area">
              
              <p>
              Pay Per Click (PPC) marketing is a paid search strategy designed to build brand awareness, promote your products or services, and quickly attract targeted audience segments. The key feature of PPC is that advertisers only pay when a user actually clicks on their ads — hence the name, pay-per-click.
              </p>
              <p>
              Many people immediately think of Google PPC management when they hear about pay per click. However, PPC extends far beyond just Google Search results and the Google Display Network. Popular social media platforms like YouTube, Facebook, Pinterest, and LinkedIn also utilize the pay per click model to help businesses reach their ideal customers.
              </p>
              <p>
              At Raj Digital Marketing, we leverage PPC across multiple platforms to maximize your reach and deliver fast, measurable results.
              </p>
              <p>
                
              </p>
            </div>
          </div>
        );
      case 'Tab3':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>How Does PPC Marketing Work?</h1>
            </div>
            <div className="main-para-area">
              
              <p>
              PPC advertising revolves around keywords. Platforms like Google Ads assign a value to various search terms based on factors such as search volume, competition, and difficulty. Simply put, the more advertisers bidding on the same keyword, the higher its cost.
              </p>
              <p>
              Since advertising platforms have limited paid placement spots—like Google’s search results page—businesses must compete to secure these valuable positions. However, it’s not just about paying the most; PPC platforms use complex algorithms that consider factors like ad quality and relevance to determine which ads get prime placement.
              </p>
              <p>
              At Raj Digital Marketing, we expertly manage your PPC campaigns to help you win the right spots at the right price, ensuring your ads reach the customers who matter most.
              </p>
              <p>
                
              </p>
            </div>
          </div>
        );
      case 'Tab4':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>Why Pay Per Click Marketing Works For Your Business</h1>
            </div>
            <div className="main-para-area">
              <p>
              PPC advertising is a highly effective digital marketing strategy designed to boost your conversions and maximize your return on investment. 
              </p>
              <p>
              With data-driven PPC management, Raj Digital Marketing creates targeted opportunities that connect your brand directly with potential customers—helping you grow your business and increase profitability.
              </p>
              {/* <p>
                If your business has clear growth targets, partner with NEXA to achieve these. This is done through
                smart and personalized digital marketing services, creative thinking, and transformative technology,
                ensuring effective and measurable results.
              </p>
              <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p> */}
            </div>
          </div>
        );
      case 'Tab5':
        return (
            <div className="tab-contain-full">
            <div className="main-tab-heading1">
              <h1>PPC Agency That Delivers Results</h1>
            </div>
            <div className="main-para-area">
              
              <p>
              We Optimize Your Paid Accounts to Save You Time and Money
Since 2020, Raj Digital Marketing has been empowering businesses with comprehensive pay-per-click solutions that boost market performance. Our PPC advertising agency leverages data and analytics to scale your campaigns efficiently and help you achieve your marketing goals.

              </p>
              <p>
              Discover how Raj Digital Marketing has transformed digital marketing success for businesses across industries.
              </p>
              {/* <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p>
              <p>
                Digital Marketing Services that are aligned to your business' growth targets. By implementing a
                strategy-first approach, our team identifies the right approach aligned to the goals of your
                business. This process includes a full competitor audit together with an outline of the messaging,
                content, and services required to achieve your business' growth targets.
              </p> */}
            </div>
          </div>
        );
      default:
        return <div>Select a tab to see content</div>;
    }
  };

  return (
    <>
      <div className="container main-ads-img-01">
        <div className="main-ads-img01">
          <img src={main14} alt="Main Advertisement" />
        </div>
      </div>

      <div className="container tabs-ads-main-container">
        <div className="row row-cols-2 tab-area-main">
          <div className="col main-tabs-area">
            <ul className="main-tab-list">
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab1')}autoFocus style={{outline:0}}>
                What Is Pay Per Click and How Does It Work?
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab2')}>
                What is PPC?
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab3')}>
                How Does PPC Marketing Work?
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab4')}>Why Pay Per Click Marketing Works...
                </button>
              </li>
              <li className="tabs-text-area">
                <button onClick={() => handleTabClick('Tab5')}>
                PPC Agency That Delivers Results
                </button>
              </li>
            </ul>
          </div>
          <div className="col main-contain-area-tabs">
            {renderContent()}
          </div>
        </div>
      </div>
    </>
  );
}
